import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["defaultValue"];
import React, { useRef } from 'react';
import { useMergeRefs } from '@tui-react/core';
import { useValueState } from './useValueState';
import { useFocusedState } from './useFocusedState';
export const withValueInputState = (Component, {
  emptyValue
}) => /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
  const restProps = _objectWithoutPropertiesLoose(props, _excluded);
  const ref = useRef(null);
  const propsWithState = _extends({}, restProps, useValueState(_extends({}, props, {
    emptyValue
  }), ref), useFocusedState(props));
  return /*#__PURE__*/React.createElement(Component, _extends({}, propsWithState, {
    ref: useMergeRefs([ref, forwardedRef])
  }));
});